import "./styles.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../context/ConfigContext";
import { useTranslation } from "react-i18next";
import { generateUUID } from "../../services/uidService";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { ScifiWireAnimation } from "../animations/ScifiWireAnimation/ScifiWireAnimation";
import Button from "../Button/Button";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";
import { useTracker } from "../../context/TrackerContext";

export const MobilePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation(["customHomeInfo"]);
  const { updateUID, uid } = useUID();
  const trackEvent = useAmplitude();
  const { itrack } = useTracker();
  const { logo, configData } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isScanned = params.get("scanned");
    const uid = generateUUID();

    updateUID(uid);

    // Log events if user scanned QR and visited on mobile
    // If user visited first time from QR-scan
    if (isScanned) {
      itrack({ eventName: "scanned_qr", trackerId: uid });
      trackEvent("webapp_user_scanned_qr", uid);
      params.delete("scanned");
      // Update the URL without reloading the page
      navigate(
        {
          pathname: window.location.pathname,
          search: params.toString(),
        },
        { replace: true },
      );
    }

    itrack({ eventName: "visited_home_page", trackerId: uid });
    trackEvent("webapp_user_visited_home", uid);
  }, [navigate, updateUID, trackEvent, itrack, i18n]);

  return (
    <>
      <ScifiWireAnimation targetRadius={240} />
      <div className="customer-logo-container">
        <img
          src={logo}
          alt="Logo"
          width="320"
          style={{
            width: "50vmin",
            maxWidth: "360px",
          }}
        />
      </div>
      {configData?.availableLanguages?.length > 1 && (
        <div className="language-selector">
          <LanguageSelector />
        </div>
      )}
      <div className="info-text">
        <h2 className="title-text">{t("custom-home-title")}</h2>
        <p className="home-sub-title">{t("custom-home-subtitle")}</p>
      </div>
      <div className="home-button-wrapper">
        <Button
          text={t("custom-home-button")}
          onClick={() => {
            itrack({
              eventName: "pressed_continue_home_page",
              trackerId: uid,
            });
            trackEvent("webapp_user_press_continue_home", uid);
            onFinish();
          }}
        />
      </div>
    </>
  );
};
